export default __webpack_public_path__ + "034b11192f301ea66667965c4c028e10.png";